/**
 * Total-item count label for server-backed grids.
 *
 * The small "{n} items" readout that tells a user how many records the
 * current grid query matched. Rendered inside the grid's search input
 * (toolbar quick-filter or the scope-search variant) so the count sits
 * with the thing that narrows it; falls back to the toolbar when a grid
 * has no search. Hidden until the first response locks a real count.
 */
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function GridItemCount({ count, noun, sx }) {
  const { t } = useTranslation();
  // The grid hook locks the count to null until the first response lands.
  if (count == null) return null;
  // `noun` lets a grid label its rows ("24 batches", "24 sites") instead of
  // the generic "24 items". The caller passes an already-translated, plural
  // noun so it owns the i18n.
  const label = noun
    ? t('dataGrid.totalItemsNoun', '{{count, number}} {{noun}}', { count, noun })
    : t('dataGrid.totalItems', '{{count, number}} items', { count });
  return (
    <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, whiteSpace: 'nowrap', ...sx }}>
      {label}
    </Typography>
  );
}
